/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import ReactFileReader from 'react-file-reader';
import * as _ from 'underscore';
import importerModule from 'app/mixins/ImporterModule.js';
import ImportResults from 'app/components/Importer/ImportResults.jsx';
import Loading from 'app/components/common/Loading.jsx';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import { compose } from 'redux';

class CSVImporter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadError: null,
            importError: null,
            selectedSocials: [],
            importComplete: false,
            twitterOutputs: [],
            pollId: 0
        };

        // bind class functions here
        this.onFileUpload = this.onFileUpload.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            uploadError = [],
            importError = [];

        uploadError = props.getApiErrors(['BULK_UPLOAD']);
        if (uploadError.length && state.uploadError === null) {
            nextState.uploadError = uploadError[0].errors;
        } else if (!uploadError.length && state.uploadError !== null) {
            nextState.uploadError = null;
        }

        importError = props.getApiErrors(['BULK_POST']);
        if (importError.length && state.importError === null) {
            nextState.importError = importError[0].errors;
        } else if (!importError.length && state.importError !== null) {
            nextState.importError = null;
        }

        return (Object.keys(nextState).length) ? nextState : null;
    }

    componentDidMount() {

        if (this.props.socials.list.length === 0) {
             this.props.getSocials();
        }

        // clear out any prior results from say, a twitter import
        this.props.resetBulk();

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.socials.list.length !== this.props.socials.list.length) {
            let temp = [],
                twitterOutputs = [],
                constants = this.props.app.config.constants;

            temp = _.filter(this.props.socials.list, function(social){
                return constants.POST_SVC_TWITTER == social.psID;
            });

            if (temp.length) {
                for (let key in temp) {
                    twitterOutputs.push(temp[key].id);
                }
            }

            this.setState({
                twitterOutputs
            });

        }

        if (prevProps.bulk.token === 0 && this.props.bulk.token !== 0) {
            let pollId = setInterval(() => {
                this.props.getBulkStatus(this.props.bulk.token);
            }, 1500);

            this.setState({
                pollId
            });
        }

        if (prevProps.bulk.token !== 0 && this.props.bulk.token === 0) {
            clearInterval(this.state.pollId);
            this.setState({
                pollId: 0
            });
        }

        if (prevProps.bulk.completedImports < this.props.bulk.completedImports) {
            this.setState({
                selectedSocials: [],
                importComplete: true
            });
        }

    }

    onFileUpload(files) {

        this.props.uploadBulkItems(files);
        this.props.deleteApiError(['BULK_UPLOAD', 'BULK_POST']);

        this.setState({
            importError: null
        });

    }

    render() {
        let content = null,
            results = null,
            constants = this.props.app.config.constants,
            errors = [];

        if (!this.props.user.perms.resources.bulkImport) {
            content = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="contentImport"/>
            );
            return (
                <Content main={content}/>
            );
        }

        if ((this.props.app.loading.BULK_RESULTS || this.props.app.loading.BULK_UPLOAD) || this.props.bulk.token !== 0) {
            let progress = "...";
            if (this.props.bulk.status !== null) {
                progress = " " + (parseFloat(this.props.bulk.status) * 100).toFixed(0) + "%";
            }
            results = (
                <div className="import-loader empty">
                    <Loading label={`Importing${progress}`}/>
                </div>
            );
        } else if (this.props.bulk.searchResults.length > 0 || this.state.uploadError !== null) {
            if (this.state.uploadError) {
                let serverSaid = this.state.uploadError.validation?.media;
                results = (
                    <div className="import-loader error">
                        Sorry, we couldn't import your CSV for you.{serverSaid ? ` The server said: ${serverSaid}` : ''}
                    </div>
                );
            } else {
                results = (
                    <ImportResults
                        {...this.props}
                        context='csv'
                        items={this.props.bulk.searchResults}
                        service={0}
                        chooseSocials={this.onChooseSocials}
                        selectedSocials={this.state.selectedSocials}
                        onImportItems={this.onImportItems}
                        importComplete={this.state.importComplete}
                        categories={this.props.categories}
                        importError={this.state.importError}
                        onSocialsSelected={this.onSocialsSelected}
                        twitterOutputs={this.state.twitterOutputs} />
                );
            }
        } else {
            results = (
                <div className="import-results-wrapper empty"></div>
            );
        }

        content = (
            <div className="importer-main">
                <div className="import-search-block">
                    <h2>Import a CSV</h2>
                    <div className="csv-importer">
                        <div className="format-instructions">
                            <p>
                                You can upload a CSV of your content and add items directly to your social queues or EverQueues.
                                We expect the data in the following format (if you include the header, be sure it's the first row):
                            </p>
                            <pre>
                                comment, url, imageUrl
                            </pre>
                        </div>
                        <ReactFileReader handleFiles={this.onFileUpload} fileTypes='text/csv'>
                            <button className="btn-primary active csv-button">Upload CSV</button>
                        </ReactFileReader>
                    </div>
                </div>
                {results}
            </div>
        );

        return (
            <Content header={null} main={content}/>
        );
    }
}

CSVImporter.displayName = "CSVImporter";

const enhance = compose(
    ComponentWithContext,
    importerModule
);

export default enhance(CSVImporter);
